<template>
  <div>
    <div id="container">
      <i class="fa fa-spinner spin fa-3x text-white" v-if="value"></i>
      <iframe :src="src" v-if="!value"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'previewPdf',
  props: ['value', 'src'],
  data() {
    return {}
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 80vh;
  background: rgb(93, 94, 95);
  text-align: center;
}
#container iframe {
  width: 100%;
  height: 80vh;
  border: 2px solid #acacac;
}
#container i {
  margin-top: 32vh;
  color: white;
}
</style>
